const emoTextList = ['憨笑', '媚眼', '开心', '坏笑', '可怜', '爱心', '笑哭', '拍手', '惊喜', '打气',
	'大哭', '流泪', '饥饿', '难受', '健身', '示爱', '色色', '眨眼', '暴怒', '惊恐',
	'思考', '头晕', '大吐', '酷笑', '翻滚', '享受', '鼻涕', '快乐', '雀跃', '微笑',
	'贪婪', '红心', '粉心', '星星', '大火', '眼睛', '音符', "叹号", "问号", "绿叶",
	"燃烧", "喇叭", "警告", "信封", "房子", "礼物", "点赞", "举手", "拍手", "点头",
	"摇头", "偷瞄", "庆祝", "疾跑", "打滚", "惊吓", "起跳"
];


let transform = (content, extClass) => {
	return content.replace(/\#[\u4E00-\u9FA5]{1,3}\;/gi, (text) => textToImg(text, extClass));
}

// 将匹配结果替换表情图片
let textToImg = (emoText, extClass) => {
	let word = emoText.replace(/\#|\;/gi, '');
	let idx = emoTextList.indexOf(word);
	if (idx == -1) {
		return emoText;
	}
	let url = require(`@/assets/emoji/${idx}.gif`);
	return `<img src="${url}" class="${extClass}" />`
}

let textToUrl = (emoText) => {
	let word = emoText.replace(/\#|\;/gi, '');
	let idx = emoTextList.indexOf(word);
	if (idx == -1) {
		return "";
	}
	let url = require(`@/assets/emoji/${idx}.gif`);
	return url;
}

const FLAG_EMOJI_RE = /(?:\uD83C[\uDDE6-\uDDFF]){2}/g;
const FLAG_EMOJI_ONLY_RE = /^(?:\uD83C[\uDDE6-\uDDFF]){2}$/;

function isFlagEmoji(text) {
	return FLAG_EMOJI_ONLY_RE.test(String(text || ''));
}

function wrapFlagEmojisHtml(content) {
	if (!content) {
		return content;
	}
	let inFlagSpan = 0;
	return String(content).replace(/<[^>]+>|(?:\uD83C[\uDDE6-\uDDFF]){2}/g, (token) => {
		if (token.charAt(0) === '<') {
			if (/^<span\b[^>]*\bemoji-flag\b/i.test(token)) {
				inFlagSpan++;
			} else if (/^<\/span>/i.test(token) && inFlagSpan > 0) {
				inFlagSpan--;
			}
			return token;
		}
		if (inFlagSpan > 0) {
			return token;
		}
		return `<span class="emoji-flag">${token}</span>`;
	});
}

function splitByFlagEmoji(text) {
	const source = text == null ? '' : String(text);
	const parts = [];
	if (!source) {
		return parts;
	}
	FLAG_EMOJI_RE.lastIndex = 0;
	let last = 0;
	let match;
	while ((match = FLAG_EMOJI_RE.exec(source)) !== null) {
		if (match.index > last) {
			parts.push({ type: 'text', value: source.slice(last, match.index) });
		}
		parts.push({ type: 'flag', value: match[0] });
		last = match.index + match[0].length;
	}
	if (last < source.length) {
		parts.push({ type: 'text', value: source.slice(last) });
	}
	return parts;
}

function createFlagElement(flag) {
	const el = document.createElement('span');
	el.className = 'emoji-flag';
	el.textContent = flag;
	return el;
}

function isProtectedFlagParent(el) {
	while (el && el.nodeType === 1) {
		if (el.classList && el.classList.contains('emoji-flag')) {
			return true;
		}
		if (el.dataset && (el.dataset.id || el.dataset.imgId || el.dataset.fileId)) {
			return true;
		}
		if (el.getAttribute && el.getAttribute('contenteditable') === 'false') {
			return true;
		}
		el = el.parentElement;
	}
	return false;
}

function replaceFlagsInElement(root) {
	if (!root || typeof document === 'undefined' || !document.createTreeWalker) {
		return;
	}
	const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
	const nodes = [];
	while (walker.nextNode()) {
		nodes.push(walker.currentNode);
	}
	nodes.forEach((node) => {
		const parent = node.parentNode;
		if (!parent || isProtectedFlagParent(parent)) {
			return;
		}
		const parts = splitByFlagEmoji(node.textContent);
		if (!parts.some((part) => part.type === 'flag')) {
			return;
		}
		const frag = document.createDocumentFragment();
		parts.forEach((part) => {
			if (part.type === 'flag') {
				frag.appendChild(createFlagElement(part.value));
			} else if (part.value) {
				frag.appendChild(document.createTextNode(part.value));
			}
		});
		parent.replaceChild(frag, node);
	});
}

function unwrapFlagElementsHtml(html) {
	return String(html || '').replace(/<(a|span)\b[^>]*\bemoji-flag\b[^>]*>([\s\S]*?)<\/\1>/gi, '$2');
}

const yanWordList = [
	"😀", "😃", "😄", "😁", "😆", "😅", "😂", "🤣", "🥲", "😊", "😇", "🙂", "🙃", "😉", "😌", "😍", "🥰", "😘", "😗", "😙", "😚", "😋",
	"😛", "😝", "😜", "🤪", "🤨", "🧐", "🤓", "😎", "🥸", "🤩", "🥳", "😏", "😒", "😞", "😔", "😟", "😕", "🙁", "☹️", "😣", "😖", "😫", "😩", "🥺", "😢", "😭",
	"😤", "😠", "😡", "🤬", "🤯", "😳", "🥵", "🥶"
]

export default {
	emoTextList,
	transform,
	textToImg,
	textToUrl,
	isFlagEmoji,
	wrapFlagEmojisHtml,
	splitByFlagEmoji,
	createFlagElement,
	replaceFlagsInElement,
	unwrapFlagElementsHtml,
	yanWordList
}
